exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Raleway:100,400);", ""]);

// module
exports.push([module.id, "body{background-color:#add8e6;color:#35342f;display:flex;justify-content:center;font-family:Raleway,sans-serif}.main-app-container{padding-top:2em}.main-app-nav{font-size:2em;text-align:center}.todo-container{display:flex;flex-flow:row wrap;justify-content:space-around}.todo-item{border-radius:7px;background:#90ee90;padding:30px;margin:10px;width:200px}button{background-color:pink;padding:5px;margin-left:3px}button:hover{background-color:#dd6464}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/styles/main.scss
 ** module id = 144
 ** module chunks = 0
 **/